import { KovResourcePicker } from '@kathondvla/react-shared-components/src/components';
import type { EditAsideMinimumGoal } from '@nodeTypeConfig/configTypes';
import {
  addRelationAction,
  patchRelationAction,
  removeRelationAction,
} from '@store/actions/documentActions';
import { any } from 'prop-types';
import type React from 'react';
import { useDispatch } from 'react-redux';
import { useEditHref } from '../../../hooks/UseEditHref';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import {
  selectCurrentMinimumGoalRelation,
  selectMinimumGoalOptions,
} from './asideMinimumGoalSelectors';

const AsideMinimumGoal: React.FC<{
  config: EditAsideMinimumGoal;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const dispatch = useDispatch();
  const editHref = useEditHref();

  const options = useTypedSelector(selectMinimumGoalOptions);
  const currentRelation = useTypedSelector((state) =>
    selectCurrentMinimumGoalRelation(state, editHref, config),
  );

  const defaultValue =
    currentRelation?.to?.href && options.find((option) => option.href === currentRelation.to.href);
  const pickerKey = defaultValue?.href || 'empty';

  const onChange = (selection: (typeof options)[number] | null) => {
    const selectedHref = selection?.href;

    if (!selectedHref && currentRelation) {
      dispatch(removeRelationAction(currentRelation.key));
    }

    if (selectedHref && currentRelation) {
      dispatch(
        patchRelationAction(currentRelation.key, {
          to: { href: selectedHref },
        }),
      );
    }

    if (selectedHref && !currentRelation) {
      const relationType = config.options.relationTypes[0] || 'IMPLEMENTS';
      dispatch(
        addRelationAction({
          relationtype: relationType,
          from: { href: editHref },
          to: { href: selectedHref },
        }),
      );
    }
  };

  return (
    <div>
      <label className="control-label">{config.label}</label>
      <KovResourcePicker
        key={pickerKey}
        localData={options}
        display="name"
        optionTemplate={(option: (typeof options)[number]) => (
          <span dangerouslySetInnerHTML={{ __html: option.name }} />
        )}
        defaultValue={defaultValue}
        clearable={config.options.clearable}
        disabled={readonly}
        disableSearch={false}
        optionValue={(option: (typeof options)[number]) => option.href}
        style={{ option: (provided) => ({ ...provided, cursor: 'pointer' }) }}
        onChange={onChange}
      />
    </div>
  );
};

AsideMinimumGoal.displayName = 'AsideMinimumGoal';

AsideMinimumGoal.propTypes = {
  config: any,
  readonly: any,
};

export default AsideMinimumGoal;
